import React, { useState, useEffect, Fragment, useContext } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import SchoolSellerCourses from './SchoolSellerCourses';

const CoursesSeller = () => {

	const authContext = useContext(AuthContext);
	const { getSchoolID, schoolID } = authContext;

	useEffect(() => {
		getSchoolID();
    }, []);

	return (

		<SchoolSellerCourses 
			schoolID={schoolID}
		/>

	);
};

export default CoursesSeller;
